module.exports = __webpack_public_path__ + "img/2.12.c8b69998.png";